import {Component} from '@angular/core';

@Component({
    selector: 'sec-body',
    templateUrl: './body.component.html'
})

export class BodyComponent {

}
